export default {
  hasNewVersion: (state) => {
    return state.registration && state.registration.waiting;
  },
};
